import * as React from 'react'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'

import states from '../shared/states'

interface IStateInputProps {
  state: string
  onChange: React.ChangeEventHandler
  onBlur: (e: any) => void
  error?: boolean
}

const StateInput: React.SFC<IStateInputProps> = ({
  state,
  onChange,
  onBlur,
  error
}) => {
  return (
    <FormControl fullWidth required error={error}>
      <InputLabel>State</InputLabel>
      <Select
        name="state"
        fullWidth
        value={state}
        onChange={onChange}
        onBlur={onBlur}>
        {Object.keys(states).map(stateCode => (
          <MenuItem key={stateCode} value={stateCode}>
            {states[stateCode]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default StateInput



// WEBPACK FOOTER //
// ./src/components/shared/StateInput.tsx